/**
 * `data` is the block's own content. `properties` is the content object the
 * block sits on — which is why this block only makes sense on a Talk.
 */
const SpeakerCardView = ({ data, properties }) => {
  const speaker = properties?.speaker;

  if (!speaker) {
    return null;
  }

  return (
    <div className="ui segment speaker-card">
      <h2>{data.heading || 'About the speaker'}</h2>
      <p className="speaker-card-name">
        {speaker}
        {properties.company ? `, ${properties.company}` : ''}
      </p>
      {data.showEmail && properties.email && (
        <p className="speaker-card-email">
          <a href={`mailto:${properties.email}`}>{properties.email}</a>
        </p>
      )}
    </div>
  );
};

export default SpeakerCardView;
